import React from 'react';

import Devices from '../station-dashboard/Devices';
import StationDevicesLane from '../station-dashboard/StationDevicesLane';

import StationManagementBottomContainer from './station-details/StationManagementBottomContainer';

/**
 * Station Dashboard
 * @returns
 */
function StationDashboard() {
  return (
    <div className="station-dashboard-container">
      <div className="station-devices">
        <div className="left">
          {' '}
          <StationDevicesLane />
        </div>{' '}
        <div className="right">
          {' '}
          <Devices />
        </div>
      </div>
      <StationManagementBottomContainer />
    </div>
  );
}

export default StationDashboard;
